export default {
  apply_submit: 'Send søknad',
  apply_submitting: 'Sender inn..',
  apply_cv_label: 'CV/Sammendrag',
  apply_coverLetter_label: 'Følgebrev',
  apply_email_label: 'Epost',
  apply_name_label: 'Fullt navn',
  apply_sex_label: 'Kjønn',
  apply_ssn_label: 'Fødseldato',
  apply_phone_label: 'Telefon',
  apply_successModal_title: 'Søknad mottatt',
  apply_successModal_text:
    'En bekreftelse har blitt sendt til din epost. Hvis du ikke har mottatt den innen et par minutter, vær snill å sjekk søppelposten din.',
  apply_successModal_backToJobs: 'Tilbake til stillingsoversikten',
  he: '',
  apply_error_required: 'Dette feltet er obligatorisk',
  apply_error_email: 'Ugyldig epost',
  apply_error_ssn: 'Ugyldig fødseldato ',
  apply_connect: 'Koble til ',
  apply_connected: 'Tilkoblet',

  backToJobs: 'Tilbake til jobboversikten',
  backToDetail: 'Tilbake til stillingsbeskrivelsen',
  openings_singular: '{0} Ledig stilling',
  openings_plural: '{0} Ledige stillinger',
  no_openings: 'For øyeblikket ingen ledige stillinger',
  apply_button: 'Søk nå',
  deadline_display: 'Søknadsfrist',
  deadline_none: 'Ingen frist',
  vacancies_singular: 'ledig stilling',
  vacancies_plural: 'ledige stillinger',
  filter_search_placeholder: 'Søk...',
  openings_showing_singular: 'Viser {0} / {1} stilling',
  openings_showing_plural: 'Viser {0} / {1} stillinger',
  filter_no_results_main: 'Ingen stillinger samsvarer med søk eller filtre',
  filter_no_results_sub: 'Juster søket eller tilbakestill filtrene',
  clear_all: 'Tilbakestill alt',
  select_placeholder: 'Velg...',
  upload_file: 'Last opp fil',
  accept_terms_body_text: 'Klikke her hvis du har lest og samtykker vilkårene',
  fifty_privacy_policy: ' 50skills personvernpolicy',
  privacy_policy_and: ' og',
  company_privacy_policy: '{0} Personvernpolicy',
  terms_agreement_required: 'Det kreves samtykke for vilkårene',
  apply_form_has_errors: 'Rett opp de markerte feltene før du sender inn',
  job_list_no_openings_main: 'Ingen ledige stillinger for øyeblikket',
  job_list_no_openings_sub: 'Vennligst kom tilbake ved en annen anledning!',
  job_list_no_language_data: 'Denne stillingsannonsen er foreløpig ikke tilgjengelig på norsk',
  job_list_no_language_data_sub:
    'For å se stillingsannonsen på et annet språk, bytt språk øverst i høyre hjørnet.',
  jobStatus_full_time: 'Fulltidsstilling',
  jobStatus_part_time: 'Deltidsstilling',
  jobStatus_per_diem: 'Timelønn',
  jobStatus_not_specified: 'Ikke spesifisert',
  en: 'English',
  is: 'Íslenska',
  pl: 'Polski',
  no: 'Norsk',
  sv: 'Svenska',
  fr: 'Français',
  languageSwitcher_title: 'Velg språk',
  'The submitted file is empty.': 'Den innsendte filen er tom.',
  job_does_not_exist_header: 'Siden du ser etter finnes ikke',
  job_does_not_exist_sub_header:
    'Mulig du har skrevet feil eller så har jobbannonsen blitt fjernet',
  job_does_not_exist_link: 'Ta med tilbake til hovedsiden',
  fiftyFooter_poweredBy: 'Powered by',
  jobStatus_title: 'Jobbstatus',
  cookie_consent_main_text: 'Ved å bruke nettstedet godtar du vår',
  cookie_consent_privacy_cta_text: ' policy for informasjonskapsler.',
  cookie_consent_privacy_button_text: 'Avskjedige',
  department_title: 'Avdeling',
  department_unspecified: 'Ikke spesifisert',
};
